module.exports = "https://static.energy5.com/_next/static/images/batteryBgMob-e5ebb95721832dcfaa927622df14780b.webp";